<template>
    <div v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container" style="position: relative">
            <span>登錄</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div class="login-container">

            <div style="padding: 20px">
                <img src="../assets/img_logo.png" alt="" style="width: 20%" />
            </div>

            <div class="input-container">
                <img src="../assets/img_phone.png" alt="">
                <input v-model="userName" placeholder="請輸入用戶名">
            </div>

            <div class="input-container" style="margin-top: 20px">
                <img src="../assets/img_confirm_pwd.png" alt="">
                <input type="password" v-model="password" placeholder="請輸入密碼">
            </div>

            <button @click="login">登錄</button>

            <button @click="startFacebookLogin" style="margin-top: 10px">Facebook登錄</button>

            <div style="margin-top: 10px">
                <a href="https://b.mysread.com/d_238375.html" style="color: dodgerblue" target="_self">隱私政策服務協議</a>
            </div>

            <div style="margin-top: 20px">
                <a href="">忘記密碼</a>
                <span style="margin-left: 10px;margin-right: 10px">|</span>
                <a @click="register">註冊賬號</a>
            </div>

        </div>

    </div>
</template>

<script>
import axios from "axios";

let _this;

export default {
    name: "LoginVue",
    data() {
        return {
            userName: "",
            password: "",
            loginData: [],
            isRequest: false,
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },

        //登錄
        login: function () {
            if (this.userName === null || this.userName === "") {
                alert("請輸入用戶名");
                return;
            }
            if (this.password === null || this.password === "") {
                alert("請輸入密碼");
                return;
            }
            localStorage.setItem("userName", this.userName);
            localStorage.setItem("pwd", this.password);
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "login");
            params.append("mobile", this.userName);
            params.append("pwd", this.password);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.loginData = res.data.data;
                    localStorage.setItem("userId", this.loginData.id);
                    localStorage.setItem("token", this.loginData.token);
                    this.$router.go(-1);
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //註冊
        register: function () {
            this.$router.push({
                path: "RegisterVue",
                query: {
                    vueName: "LoginVue",
                },
            });
        },

        startFacebookLogin: function () {
            FB.login(
                function (response) {
                    if (response.status === "connected") {
                        _this.facebookLoginSuccess();
                    } else {
                        alert("Facebook登錄失敗");
                    }
                },
                { scope: "public_profile,email" }
            );
        },

        facebookLoginSuccess: function () {
            FB.api("/me", function (response) {
                const requestUrl = "https://b.mysread.com/api6.php";
                const params = new URLSearchParams();
                params.append("language", "zh-Hant");
                params.append("dev", "h5");
                params.append("uuid", "123456");
                params.append("ver", "1.0");
                params.append("ac", "otherLogin");
                params.append("nicheng", response.name);
                params.append("unionid", response.id);
                params.append("type", "facebook");
                params.append("openid", response.id);
                _this.isRequest = true;
                _this.$http.post(requestUrl, params).then((res) => {
                    _this.isRequest = false;
                    if (res.data.status) {
                        _this.loginData = res.data.data;
                        localStorage.setItem("userId", _this.loginData.id);
                        localStorage.setItem("token", _this.loginData.token);
                        _this.$router.push({
                            path: "MineVue",
                        });
                    } else {
                        alert(res.data.msg);
                    }
                });
            });
        },
    },

    created() {
        _this = this;
        this.userName = localStorage.getItem("userName");
        this.password = localStorage.getItem("pwd");
    },

    mounted: function () {
        (function (d, s, id) {
            let js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");

        window.fbAsyncInit = function () {
            FB.init({
                appId: "2022240274666302",
                cookie: true, // 啟用cookie
                xfbml: true, // 解析此頁面上的社交插件
                version: "v2.8", // 使用圖形api 2.8版本
            });
        };
    },
};
</script>

<style scoped>
.login-container {
    height: 100%;
    margin: 0 auto;
    max-width: 480px;
}

.input-container {
}

.input-container input {
    width: 70%;
    height: 40px;
    padding-left: 10px;
    outline: none;
    border: 1px solid gray;
    color: black;
    border-radius: 5px;
    font-size: 14px;
}

.login-container button {
    width: 70%;
    height: 35px;
    background: #f2c510;
    border: 1px solid #f2c510;
    border-radius: 5px;
    outline: none;
    color: black;
    font-size: 16px;
    margin-top: 20px;
}

.login-container button:active {
    background-color: #fc9504;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginVue.vue